import styles from '@/pages/workshop/ApplicationSection/index.module.less'
import { Col, Row, Skeleton } from 'antd'
import ApplicationItem from '@/pages/workshop/ApplicationSection/ApplicationItem.tsx'
import { tenantAppCollect, tenantAppCollectRemove } from '@/services'
import useWorkshopStore, { COLLECT_TYPE } from '@/store/workshop.ts'
import { useShallow } from 'zustand/react/shallow'
import { useNavigate } from 'react-router-dom'
import useGlobalStore from '@/store'
import { dfs } from 'shj-utils'
import useNavigateMicro from "@/hooks/useNavigateMicro.ts";

const ApplicationList = props => {
  const {
    dataSource,
    filterType,
    spanProps,
    commonlyRemoveText,
    loading,
    size,
    wrapStyle,
    wrap = true,
    gutter = 15,
  } = props
  const navigate = useNavigate()
  const {
    appNavDict,
    appCollectDict,
    setNavDict,
    setCollectDict,
    fetchCollectList,
    fetchNavList,
    navRemove,
    navAdd,
  } = useWorkshopStore(
    useShallow((state: any) => ({
      appNavDict: state.appNavDict,
      appCollectDict: state.appCollectDict,
      setNavDict: state.setNavDict,
      setCollectDict: state.setCollectDict,
      fetchCollectList: state.fetchCollectList,
      fetchNavList: state.fetchNavList,
      navRemove: state.navRemove,
      navAdd: state.navAdd,
    }))
  )

  const [navigateMicroPage] = useNavigateMicro()

  const { setMenuActive, globalMenu } = useGlobalStore(
    useShallow((state: any) => ({
      setMenuActive: state.setMenuActive,
      globalMenu: state.menu,
    }))
  )

  const reloadCollectList = () => {
    fetchCollectList()
  }
  const handleCollect = async record => {
    return tenantAppCollect(record.app.code, COLLECT_TYPE.COMMONLY_USED).then(() => {
      setCollectDict({ ...appCollectDict, [record.app.code]: record.app.code })
      reloadCollectList()
    })
  }
  const handleCollectRemove = async record => {
    return tenantAppCollectRemove(record.app.code, COLLECT_TYPE.COMMONLY_USED).then(() => {
      const { [record.app.code]: _, ...rest } = appCollectDict
      setCollectDict(rest)
      reloadCollectList()
    })
  }
  const handleAddNav = async record => {
    // NAVIGATION
    return navAdd(record)
  }
  const handleNavRemove = async record => {
    return navRemove(record.app.code)
  }

  const handleAppClick = record => {
    const url = record.app.entranceUrl
    if (url?.startsWith('http')) {
      window.open(url)
    } else {
      // 判断入口地址 在资源中是否存在，如果不存在，跳转资源第一个地址
      const menuItem = globalMenu.find(d => d.code === record.app.code)

      navigateMicroPage(record, menuItem)
      // let routeUrl = ''
      // dfs(menuItem.children, d => {
      //   if (!routeUrl && !d.children && d.path) {
      //     routeUrl = d.apppath + d.path
      //   }
      //   if (!d.children && d.path === url.replace(d.apppath, '')) {
      //     routeUrl = url
      //     return true
      //   }
      // })
      // navigate(routeUrl)
      setMenuActive(record)
    }
  }

  return (
    <div className={styles.appList} style={wrapStyle}>
      <Row gutter={gutter} wrap={wrap}>
        {dataSource
          ?.filter(d => d.app.categoryId === filterType?.id || !filterType?.id)
          ?.map?.((d: any, i) => {
            const isCollect = appCollectDict[d.app.code]
            const isNav = appNavDict[d.app.code]
            return (
              <Col key={`app_${d.id}`}  {...spanProps}>
                <ApplicationItem
                  data={d}
                  onCollect={handleCollect}
                  onAddNav={handleAddNav}
                  onCollectRemove={handleCollectRemove}
                  onNavRemove={handleNavRemove}
                  isCollect={isCollect}
                  isNav={isNav}
                  commonlyRemoveText={commonlyRemoveText}
                  onClick={() => handleAppClick(d)}
                  size={size}
                />
              </Col>
            )
          })}
        {loading ? <Skeleton active /> : null}
      </Row>
    </div>
  )
}

export default ApplicationList
